<template>
    <div>
        <Breadcrumbs main="Customer" title="Customer Insights">
            <!-- <div class="form-group">
                <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
            </div> -->
        </Breadcrumbs>

        
        <!-- <div class="form-group">
            <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
        </div> -->
        <div class="container-fluid">
            <div class="row ">
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Total Customers  </span>
                          <h4 class="mb-0 counter">{{ users }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="calendar" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Monthly Customers  </span>
                          <h4 class="mb-0 counter">{{ usersMonth }}</h4><feather type="calendar" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Weekly Customers  </span>
                          <h4 class="mb-0 counter">{{ usersWeek }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Today's Customers  </span>
                          <h4 class="mb-0 counter">{{ usersToday }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="navigation" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total Male</span>
                          <h4 class="mb-0 counter">{{ male }}</h4><feather type="navigation" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="navigation" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total Female</span>
                          <h4 class="mb-0 counter">{{ female }}</h4><feather type="navigation" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Customer (Highest Point)</span>
                          <h4 class="mb-0 counter"> {{ userPoint == '-' ? '-' : userPoint.name }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Customer Month (Highest Point)</span>
                          <h4 class="mb-0 counter"> {{ usersPointMonth == '-' ? '-' : usersPointMonth.name }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'CustomerReport',
        data() {
            return {
                reportOptions: [
                                    { value: null, text: 'Select Report' },
                                    // { value: 'T', text: 'Today' },
                                    // { value: 'YS', text: 'Yesterday' },
                                    // { value: 'W', text: 'This Week' },
                                    // { value: 'M', text: 'This Month' },
                                    { value: 'Y', text: 'This Year' },
                                    // { value: 'PW', text: 'Previous Week' },
                                    // { value: 'PM', text: 'Previous Month' },
                                    { value: 'PY', text: 'Previous Year' },
                            ],
                report: 'Y',
                users: 0,
                usersMonth: 0,
                usersWeek: 0,
                usersToday: 0,
                male: 0,
                female: 0,
                userPoint: '-',
                usersPointMonth: '-',
                items: [],
                week: null
            }
        },
        computed: {
            userAdmin() {
            return localStorage.getItem('type') == "admin" ? true : false
            },
            getUser() {
            return this.$store.getters['authentication/getUser']
            }
        },
        mounted() {
          
          // const today = moment(new Date(2023,7,8));
          // // const from_date = today.startOf('week');weekday()
          // const from_date = today.weekday();
          // const to_date = today.endOf('week');
          // console.log({
          //   from_date: from_date.toString(),
          //   today: moment().toString(),
          //   to_date: to_date.toString(),
          // });

          // // const  start = today.subtract(7, 'days')
          // // console.log(start)
          // let days = [] 
          // for (let index = 0; index < 7; index++) {

          //   const d = moment().subtract(7, 'days').add(1+index, 'days').toDate().toDateString().substring(4)
            
          //   days.push(d)
          // }
          // // console.log(days)
          // this.week = days
          this.getWeek()
        },
        created() {
            // watch and fetch
            this.$watch(
            () => this.$route.$params,
            () => {
                this.fetchData()
            },
            { immediate: true }

            )

        },
        methods: {
            fetchData() {
                
                const url = this.userAdmin ? '/users/' : '/users/'+this.getUser.name

                axios.get(url)
                  .then(response=>{
                    //
                    this.items = response.data
                    this.users = this.items.length

                    //
                    this.male = this.items.filter(u=> u.gender == 'male').length
                    this.female = this.items.filter(u=> u.gender == 'female').length

                    for (let index = 0; index < this.items.length; index++) {

                          // date
                          if (this.items[index].createdAt) {
                            this.items[index].date = this.userAdmin ? (new Date(this.items[index].createdAt)).toISOString() : (new Date(this.items[index].shops.find(s=>s.shop == this.getUser.name).createdAt)).toISOString()
                          
                          }

                          this.items[index].point = this.items[index].points.length > 0 ? this.userAdmin ? parseFloat(this.items[index].points.reduce((a, b) => a + b.point, 0) ) : parseFloat(this.items[index].points.filter(s=>s.shop == this.getUser.name).reduce((a, b) => a + b.point, 0) ) : 0
                          
                      }

                      const month = new Date().toISOString().substring(0,7)
                      const today = new Date().toISOString().substring(0,10)
                      this.usersMonth = this.items.filter(u=> u.date.includes(month)).length
                      this.usersToday = this.items.filter(u=> u.date.includes(today)).length
                      this.userPoint = this.items.reduce((a, b) =>a.point > b.point ? a : b, 1)
                      this.usersPointMonth = this.items.filter(u=> u.date.includes(month)).reduce((a, b) => a.point > b.point ? a : b, 1)

                      this.usersWeek = this.items.filter(u=> this.getWeek().includes(u.date.substring(0,10))).length
                  })
                  .catch( e => {
                    this.$swal({
                      title:"Failed!",
                      text:e.response.data,
                      type:'error'
                    });
                  })

            },
            getReport() {
                console.log(this.report)
            },
            getWeek(date) {

              var curr = date ? new Date(date) : new Date(); // get current date
              var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
              // var last = first + 6; // last day is the first day + 6

              var firstday = new Date(curr.setDate(first)).toDateString().substring(4);
              // var lastday = new Date(curr.setDate(last)).toDateString().substring(4);

              let days =[]
              //
              for (let index = 0; index < 7; index++) {

                const d = moment(firstday).add(index, 'days').toDate().toISOString().substring(0,10)
                
                days.push(d)
              }

              // console.log(days)
              return days

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>